module.exports = __webpack_public_path__ + "img/05.4ca1090e.png";